import React from "react";
import { Link } from "react-router-dom";

import { Button, IButtonProps } from "@/components/Button";
import { Text } from "@/eworkitComponents";

import "./_back-button.scss";

interface IBackButtonProps extends Partial<IButtonProps> {
  label: string;
  path: string;
}

export const BackButton: React.FunctionComponent<IBackButtonProps> = ({ label, path, variant }) => {
  const baseClass = "back-button";

  const [pathname, search] = path.split("?");

  return (
    <Link to={{ pathname, search, state: { fromBackButton: true } }}>
      <Button className={baseClass} variant={variant ? variant : "transparent"} icon="arrow_back">
        <Text className={`${baseClass}__label`}>{label}</Text>
      </Button>
    </Link>
  );
};
